// export interface QuestionType {
//   id: string;
//   name: string;
//   component: any;
// }

// export type Role = RoleType.Tester | RoleType.Principal | RoleType.TrustContact |
//   RoleType.TrustCoordinators | RoleType.KeyContact | RoleType.ExternalExaminer | RoleType.ToBeExternalExaminer;

export enum QuestionType {
  WordingOnly = 1,
  Text = 2,
  Number = 3,
  Percentile = 4,
  Currency = 5,
  DatePicker = 6,
  DateRangePicker = 7,
  Files = 8,
  DropDown = 9,
  RadioButtonHorizontal = 10,
  RadioButtonVertical = 11,
  CheckBoxHorizontal = 12,
  CheckBoxVertical = 13,
  AreaOfLaw = 14,
  RadioButtonBranchList = 15,
  RadioButtonSubQuestions = 16,
  MultiRadioBoxes = 17,
  DropDownWithText = 18,
  PerBankAccount = 19,
  PerSignatory = 20,
  ComputedCurrency = 21,
  TextArea = 23,
  AreaOfLawsV2 = 24,
  PerBankAccountV2 = 25,
  TextAndPercentile = 26,
  TextAreaConditional = 27,
  FilesConditional =28,
  RadioButtonWithFiles = 29,
}